import React from 'react';
import { useSelector } from 'react-redux';

import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { DataTable } from '@edx/paragon';

import { useModel } from '../../../../generic/model-store';
import messages from '../messages';
import SubsectionTitleCell from './SubsectionTitleCell';

function DetailedGradesTable({ intl }) {
  const {
    courseId,
  } = useSelector(state => state.courseHome);

  const {
    sectionScores,
    verticalStatuses,
  } = useModel('progress', courseId);

  return (
    sectionScores.map((chapter) => {
      const subsectionScores = chapter.subsections.filter(
        (subsection) => !!(
          subsection.hasGradedAssignment
          && (subsection.numPointsPossible > 0 || subsection.numPointsEarned > 0)),
      );

      if (subsectionScores.length === 0) {
        return null;
      }

      const statusMap = new Map([
        ['verified', 'Подтвержден'],
        ['error', 'Ошибка'],
        ['rejected', 'Отклонен'],
        ['created', 'Создан'],
        ['ready_to_start', 'Готов к началу'],
        ['started', 'Начат'],
        ['download_software_clicked', 'Готов к началу'],
        ['ready_to_submit', 'Готов к отправке'],
        ['submitted', 'Отправлен на проверку'],
        ['second_review_required', 'Отправлен на проверку'],
        ['expired', 'Срок истек'],
      ]);

      const detailedGradesData = subsectionScores.map((subsection) => ({
        subsectionTitle: <SubsectionTitleCell subsection={subsection} />,
        status: <span>{!verticalStatuses.has(subsection.blockKey) ? 'Без прокторинга' : (statusMap.get(verticalStatuses.get(subsection.blockKey).status) ?? verticalStatuses.get(subsection.blockKey).status)}</span>,
        score: <span className={subsection.learnerHasAccess ? '' : 'greyed-out'}>{subsection.numPointsEarned}/{subsection.numPointsPossible}</span>,
      }));

      return (
        <div className="my-3" key={`${chapter.displayName}-grades-table`}>
          <DataTable
            data={detailedGradesData}
            itemCount={detailedGradesData.length}
            columns={[
              {
                Header: chapter.displayName,
                accessor: 'subsectionTitle',
                headerClassName: 'h5 mb-0',
                cellClassName: 'mw-100',
              },
              {
                Header: `${intl.formatMessage(messages.status)}`,
                accessor: 'status',
                headerClassName: 'justify-content-center text-center h5 mb-0',
                cellClassName: 'align-top text-center small',
              },
              {
                Header: `${intl.formatMessage(messages.score)}`,
                accessor: 'score',
                headerClassName: 'justify-content-end h5 mb-0',
                cellClassName: 'align-top text-right small',
              },
            ]}
          >
            <DataTable.Table />
          </DataTable>
        </div>
      );
    })
  );
}

DetailedGradesTable.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(DetailedGradesTable);
